export const FORUM_FEED_HINT_NAME = 'forum_feed';
export const GROUP_SUBSCRIBED_FEED_HINT_NAME = 'group_subscribed_feed';

export type HintName = typeof FORUM_FEED_HINT_NAME | typeof GROUP_SUBSCRIBED_FEED_HINT_NAME;
